import React, { useState } from "react";
import styled from "styled-components";
import { useSelector } from 'react-redux';
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import FolderIcon from "@mui/icons-material/Folder";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ViewTree from "../../../documents/visualize_document/viewTree";
import { StyleModal } from "../../../../modal/styles";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useKeycloak } from "@react-keycloak/web";
import { getFolderInfo, deleteResource } from "../../../../../api/repositorio";

const Card = styled(Box)`
  position: relative;
  background: ${(props) => (!props.darkMode ? '#f2f6fc' : '#121212')};
  /* box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08), 0 4px 8px rgba(0, 0, 0, 0.06); */
  border-radius: 6px;
  padding: 20px;
  margin: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const ContentMenu = styled(Box)`
  position: absolute;
  right: 3px;
  top: 3px;
`;

const FolderImage = styled(FolderIcon)`
  height: 42px;
  font-size: 6.4rem;
  color: gray;
`;

const ContentIcon = styled(Box)`
  text-align: center;
  background: #fff;
  border-radius: 50px;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
`;

const FolderName = styled(Box)`
  text-align: center;
  margin-top: 5px;
  & small {
    font-size: 13px;
  }
`;

const Index = ({ id, tabId, nameDirectory, tabSelectedHandle }) => {
  const { keycloak } = useKeycloak();

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const userRole = keycloak.realmAccess.roles[0];

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const options = ["Eliminar"];

  const ITEM_HEIGHT = 48;

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const deleteFolder = () => {
    deleteResource(id, 2)
      .then((response) => {
        handleCloseMenu();
        tabSelectedHandle(tabId);
      })
      .catch((error) => console.log("error", error));
  };

  return (
    <div>
      <Card elevation={3} key={nameDirectory} darkMode={darkMode}>
        {userRole !== "Usuario" && (
          <ContentMenu>
             <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={openMenu ? "long-menu" : undefined}
              aria-expanded={openMenu ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon fontSize="small" />
            </IconButton> 
            <Menu
              id="long-menu"
              MenuListProps={{
                "aria-labelledby": "long-button",
              }}
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleCloseMenu}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: "20ch",
                },
              }}
            >
              {options.map((option) => (
                <MenuItem key={option} onClick={deleteFolder}>
                  {option}
                </MenuItem>
              ))}
            </Menu>
          </ContentMenu>
        )}
        <Box onClick={() => tabSelectedHandle(id)}>
          <ContentIcon className="icon-section">
            <FolderImage />
            <br />
            <strong style={{ color: "black" }}>
              {/* {data?.size} {data.size_name} */}
            </strong>
          </ContentIcon>
          <FolderName>
            <small>{nameDirectory}</small>
            {/* <strong className="owner-section">{data?.owner?.name}</strong> */}
          </FolderName>
        </Box>
      </Card>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={StyleModal}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Carpeta: {nameDirectory}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <ViewTree />
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default Index;

